/* eslint-disable no-use-before-define */

import _ from 'underscore';
import { PerformanceMetricBaseColumn } from './performance-metric-base-column';
import { FluctuationBaseColumn } from './fluctuations/fluctuation-base-column';

const perfMetricColumnConvertionDef = (targetColumnName, sourceColumnName) => ({
  sourceColumnName,
  sourceSortableProperty: `PerformanceMetrics/${sourceColumnName}`,
  targetSortableProperty: `PerformanceMetrics/${targetColumnName}`,
});

/**
 * Column CPA.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnCPA extends PerformanceMetricBaseColumn {
  static columnName = 'CPA';

  constructor({ i18n, helpId = 'Page_CampaignGrids_CPA' }) {
    super({
      name: ColumnCPA.columnName,
      format: 'decimal',
      helpId,
      i18n,
      columnConversion:
        perfMetricColumnConvertionDef(ColumnCPA.columnName, ColumnPartialConversionCPA.columnName),
    });
  }
}

/**
 * Column PartialConversionCPA.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnPartialConversionCPA extends PerformanceMetricBaseColumn {
  static columnName = 'PartialConversionCPA';

  constructor({ i18n, helpId = 'Page_CampaignGrids_CPA' }) {
    super({
      name: ColumnPartialConversionCPA.columnName,
      format: 'decimal',
      helpId,
      i18n,
      columnConversion:
        perfMetricColumnConvertionDef(ColumnPartialConversionCPA.columnName, ColumnCPA.columnName),
    });
  }
}

/**
 * Column Conversions.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnConversions extends PerformanceMetricBaseColumn {
  static columnName = 'Conversions';

  constructor({ i18n, helpId = 'Page_CampaignGrids_Conv' }) {
    super({
      name: ColumnConversions.columnName,
      format: 'integer',
      i18n,
      helpId,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnConversions.columnName,
        ColumnConversionsCredit.columnName
      ),
    });
  }
}

/**
 * Column ConversionsCredit (partial conversions).
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnConversionsCredit extends PerformanceMetricBaseColumn {
  static columnName = 'ConversionsCredit';

  constructor({ i18n, helpId = 'Page_CampaignGrids_Conv' }) {
    super({
      name: ColumnConversionsCredit.columnName,
      format: 'decimal',
      i18n,
      helpId,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnConversionsCredit.columnName,
        ColumnConversions.columnName
      ),
    });
  }
}

/**
 * Column RevenueOnAdSpend.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnRevenueOnAdSpend extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_ReturnAdSpend' }) {
    super({
      name: 'RevenueOnAdSpend',
      format: 'percentage-value',
      i18n,
      helpId,
    });
  }
}

/**
 * Column AdvertiserReportedRevenue.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAdvertiserReportedRevenue extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'Page_CampaignGrids_Revenue' }) {
    super({
      name: 'AdvertiserReportedRevenue',
      format: 'decimal',
      i18n,
      helpId,
    });
  }
}

/**
 * Column ConversionRate.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnConversionRate extends PerformanceMetricBaseColumn {
  static columnName = 'ConversionRate';

  constructor({ i18n, helpId = 'Page_CampaignGrids_ConvRate' }) {
    super({
      name: ColumnConversionRate.columnName,
      format: 'percentage-value',
      i18n,
      helpId,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnConversionRate.columnName,
        ColumnPartialConversionRate.columnName
      ),
    });
  }
}

/**
 * Column ColumnPartialConversionRate.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnPartialConversionRate extends PerformanceMetricBaseColumn {
  // TODO: investigate the need for this static field
  static columnName = 'PartialConversionRate';

  // FIXME: get the correct helpId
  constructor({ i18n, helpId = 'Page_CampaignGrids_ConvRate' }) {
    super({
      name: ColumnPartialConversionRate.columnName,
      format: 'percentage-value',
      i18n,
      helpId,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnPartialConversionRate.columnName,
        ColumnConversionRate.columnName
      ),
    });
  }
}

/**
 * Column AllConversionCPA.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAllConversionCPA extends PerformanceMetricBaseColumn {
  static columnName = 'AllConversionCPA';

  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_AllConvCPA' }) {
    super({
      name: ColumnAllConversionCPA.columnName,
      format: 'decimal',
      helpId,
      i18n,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnAllConversionCPA.columnName,
        ColumnAllPartialConversionCPA.columnName
      ),
    });
  }
}

/**
 * Column AllPartialConversionCPA.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAllPartialConversionCPA extends PerformanceMetricBaseColumn {
  static columnName = 'AllPartialConversionCPA';

  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_AllConvCPA' }) {
    super({
      name: ColumnAllPartialConversionCPA.columnName,
      format: 'decimal',
      helpId,
      i18n,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnAllPartialConversionCPA.columnName,
        ColumnAllConversionCPA.columnName
      ),
    });
  }
}

/**
 * Column AllConversions.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAllConversions extends PerformanceMetricBaseColumn {
  static columnName = 'AllConversions';

  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_AllConv' }) {
    super({
      name: ColumnAllConversions.columnName,
      format: 'integer',
      i18n,
      helpId,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnAllConversions.columnName,
        ColumnAllConversionsCredit.columnName
      ),
    });
  }
}

/**
 * Column AllConversionsCredit.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAllConversionsCredit extends PerformanceMetricBaseColumn {
  static columnName = 'AllConversionsCredit';

  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_AllConv' }) {
    super({
      name: ColumnAllConversionsCredit.columnName,
      format: 'decimal',
      i18n,
      helpId,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnAllConversionsCredit.columnName,
        ColumnAllConversions.columnName
      ),
    });
  }
}

/**
 * Column AllConversionRevenueOnAdSpend.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAllConversionRevenueOnAdSpend extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_AllConvROAS' }) {
    super({
      name: 'AllConversionRevenueOnAdSpend',
      format: 'percentage-value',
      i18n,
      helpId,
    });
  }
}

/**
 * Column AllConversionAdvertiserReportedRevenue.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAllConversionAdvertiserReportedRevenue extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_AllConvRevenue' }) {
    super({
      name: 'AllConversionAdvertiserReportedRevenue',
      format: 'decimal',
      i18n,
      helpId,
    });
  }
}

/**
 * Column AllConversionRate.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAllConversionRate extends PerformanceMetricBaseColumn {
  static columnName = 'AllConversionRate';

  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_AllConvRate' }) {
    super({
      name: ColumnAllConversionRate.columnName,
      format: 'percentage-value',
      i18n,
      helpId,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnAllConversionRate.columnName,
        ColumnAllPartialConversionRate.columnName
      ),
    });
  }
}

/**
 * Column AllPartialConversionRate.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAllPartialConversionRate extends PerformanceMetricBaseColumn {
  static columnName = 'AllPartialConversionRate';

  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_AllConvRate' }) {
    super({
      name: ColumnAllPartialConversionRate.columnName,
      format: 'percentage-value',
      i18n,
      helpId,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnAllPartialConversionRate.columnName,
        ColumnAllConversionRate.columnName
      ),
    });
  }
}

/**
 * Column ViewThroughConversions.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnViewThroughConversions extends PerformanceMetricBaseColumn {
  static columnName = 'ViewThroughConversions';

  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_ViewThrough' }) {
    super({
      name: ColumnViewThroughConversions.columnName,
      format: 'integer',
      i18n,
      helpId,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnViewThroughConversions.columnName,
        ColumnViewThroughConversionsCredit.columnName
      ),
    });
  }
}

/**
 * Column ViewThroughConversionsCredit.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnViewThroughConversionsCredit extends PerformanceMetricBaseColumn {
  static columnName = 'ViewThroughConversionsCredit';

  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_ViewThrough' }) {
    super({
      name: ColumnViewThroughConversionsCredit.columnName,
      format: 'decimal',
      i18n,
      helpId,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnViewThroughConversionsCredit.columnName,
        ColumnViewThroughConversions.columnName
      ),
    });
  }
}

/**
 * Column ViewThroughConversionsRevenue.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnViewThroughConversionsRevenue extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'pop_BA_Reporting_Clarity_ViewThroughConvRevenue' }) {
    super({
      name: 'ViewThroughConversionsRevenue',
      format: 'decimal',
      i18n,
      helpId,
    });
  }
}

/**
 * Column ViewThroughConversionsCPA.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnViewThroughConversionsCPA extends PerformanceMetricBaseColumn {
  static columnName = 'ViewThroughConversionsCPA';

  constructor({ i18n, helpId = 'pop_BA_Reporting_Clarity_ViewThroughConvCPA' }) {
    super({
      name: ColumnViewThroughConversionsCPA.columnName,
      format: 'decimal',
      i18n,
      helpId,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnViewThroughConversionsCPA.columnName,
        ColumnViewThroughPartialConversionsCPA.columnName
      ),
    });
  }
}

/**
 * Column ViewThroughPartialConversionsCPA.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnViewThroughPartialConversionsCPA extends PerformanceMetricBaseColumn {
  static columnName = 'ViewThroughPartialConversionsCPA';

  constructor({ i18n, helpId = 'pop_BA_Reporting_Clarity_ViewThroughConvCPA' }) {
    super({
      name: ColumnViewThroughPartialConversionsCPA.columnName,
      format: 'decimal',
      i18n,
      helpId,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnViewThroughPartialConversionsCPA.columnName,
        ColumnViewThroughConversionsCPA.columnName
      ),
    });
  }
}

/**
 * Column ViewThroughConversionsReturnOnAdSpend.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnViewThroughConversionsReturnOnAdSpend extends PerformanceMetricBaseColumn {
  static columnName = 'ViewThroughConversionsReturnOnAdSpend';

  constructor({ i18n, helpId = 'pop_BA_Reporting_Clarity_ViewThroughConvReturnOnAdSpend' }) {
    super({
      name: 'ViewThroughConversionsReturnOnAdSpend',
      format: 'percentage-value',
      i18n,
      helpId,
    });
  }
}

/**
 * Column ViewThroughConversionsRate.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnViewThroughConversionsRate extends PerformanceMetricBaseColumn {
  static columnName = 'ViewThroughConversionsRate';

  constructor({ i18n, helpId = 'pop_BA_Reporting_Clarity_ViewThroughConvRate' }) {
    super({
      name: ColumnViewThroughConversionsRate.columnName,
      format: 'percentage-value',
      i18n,
      helpId,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnViewThroughConversionsRate.columnName,
        ColumnViewThroughPartialConversionsRate.columnName
      ),
    });
  }
}

/**
 * Column ViewThroughPartialConversionsRate.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnViewThroughPartialConversionsRate extends PerformanceMetricBaseColumn {
  static columnName = 'ViewThroughPartialConversionsRate';

  constructor({ i18n, helpId = 'pop_BA_Reporting_Clarity_ViewThroughConvRate' }) {
    super({
      name: ColumnViewThroughPartialConversionsRate.columnName,
      format: 'percentage-value',
      i18n,
      helpId,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnViewThroughPartialConversionsRate.columnName,
        ColumnViewThroughConversionsRate.columnName
      ),
    });
  }
}


/**
 * Column Conversions with Fluctuation.
 * @extends FluctuationBaseColumn
 */
export class ColumnConversionsWithFluctuation extends FluctuationBaseColumn {
  static columnName = 'Conversions';

  constructor({ i18n, helpId = 'Page_CampaignGrids_Conv', permissions }) {
    super({
      name: ColumnConversionsWithFluctuation.columnName,
      format: 'integer',
      i18n,
      helpId,
      permissions,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnConversionsWithFluctuation.columnName,
        ColumnConversionsCreditWithFluctuation.columnName
      ),
    });
  }
}

/**
 * Column ConversionsCredit (partial conversions) with Fluctuation.
 * @extends FluctuationBaseColumn
 */
export class ColumnConversionsCreditWithFluctuation extends FluctuationBaseColumn {
  static columnName = 'ConversionsCredit';

  constructor({ i18n, helpId = 'Page_CampaignGrids_Conv', permissions }) {
    super({
      name: ColumnConversionsCreditWithFluctuation.columnName,
      format: 'decimal',
      i18n,
      helpId,
      permissions,
      columnConversion: perfMetricColumnConvertionDef(
        ColumnConversionsCreditWithFluctuation.columnName,
        ColumnConversionsWithFluctuation.columnName
      ),
    });
  }
}

/**
 * Column SalesCount .
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnSalesCount extends PerformanceMetricBaseColumn {
  constructor({ i18n, helpId = 'pop_BA_CampaignGrids_Sale' }) {
    super({
      name: 'SalesCount',
      format: 'integer',
      i18n,
      helpId,
    });
  }
}

export class ColumnInstalls extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'Installs',
      format: 'integer',
      i18n,
      helpId: 'pop_BA_StoreAds_Install',
    });
  }
}

export class ColumnCostPerInstall extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'CostPerInstall',
      format: 'decimal',
      i18n,
      helpId: 'pop_BA_StoreAds_CostPerInstall',
    });
  }
}

export class ColumnRevenuePerInstall extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'RevenuePerInstall',
      format: 'decimal',
      i18n,
      helpId: 'pop_BA_StoreAds_RevenuePerInstall',
    });
  }
}

/**
 * Column AllConversionAdvertiserReportedRevenue.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAdvertiserReportedRevenueAdjustment extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'AdvertiserReportedRevenueAdjustment',
      title: _TL_('Revenue adj.'),
      format: 'decimal',
      i18n,
      helpId: 'pop_BA_CampaignGrids_RevenueAdjustment',
    });
  }
}

/**
 * Column AllConversionAdvertiserReportedRevenue.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnAllConversionAdvertiserReportedRevenueAdjustment extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'AllConversionAdvertiserReportedRevenueAdjustment',
      title: _TL_('All revenue adj.'),
      format: 'decimal',
      i18n,
      helpId: 'pop_BA_CampaignGrids_AllRevenueAdjustment',
    });
  }
}

/**
 * Column ColumnViewThroughConversionsRevenueAdjustment.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnViewThroughConversionsRevenueAdjustment extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'ViewThroughConversionsRevenueAdjustment',
      title: _TL_('View-through revenue adj.'),
      format: 'decimal',
      i18n,
      helpId: 'pop_BA_CampaignGrids_ViewthroughRevenueAdjustment',
    });
  }
}

/**
 * Column NewCustomerConversions.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnNewCustomerConversions extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'NewCustomerConversions',
      format: 'integer',
      i18n,
      helpId: 'pop_BA_PMAX_NewCustomerConv',
    });
  }
}

/**
 * Column NewCustomerConversionsValue.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnNewCustomerRevenue extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'NewCustomerRevenue',
      format: 'decimal',
      i18n,
      helpId: 'pop_BA_PMAX_NewCustomerConvValue',
    });
  }
}

/**
 * Column NewCustomerConversionsRate.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnNewCustomerConversionRate extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'NewCustomerConversionRate',
      format: 'percentage-value',
      i18n,
      helpId: 'pop_BA_PMAX_NewCustomerConvRate',
    });
  }
}

/**
 * Column NewCustomerConversionsCPA.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnNewCustomerCPA extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'NewCustomerCPA',
      format: 'decimal',
      i18n,
      helpId: 'pop_BA_PMAX_NewCustomerConCPA',
    });
  }
}

/**
 * Column NewCustomerConversionsReturnOnAdSpend.
 * @extends PerformanceMetricBaseColumn
 */
export class ColumnNewCustomerRevenueOnAdSpend extends PerformanceMetricBaseColumn {
  constructor({ i18n }) {
    super({
      name: 'NewCustomerRevenueOnAdSpend',
      format: 'percentage-value',
      i18n,
      helpId: 'pop_BA_PMAX_NewCustomerConROAS',
    });
  }
}


export const getConversionColumns = ({
  withFluctuations = false,
  withPartialConversions = false,
  isCPSEnabled = false,
  isInstallColumnsEnabled = false,
  isConversionValueRuleColumnsEnabled = false,
  isNewCustomerAcquisitionColumnsEnabled = false,
} = {}) => _.compact([
  withPartialConversions ? ColumnPartialConversionCPA : ColumnCPA,
  withFluctuations && withPartialConversions && ColumnConversionsCreditWithFluctuation,
  withFluctuations && !withPartialConversions && ColumnConversionsWithFluctuation,
  !withFluctuations && withPartialConversions && ColumnConversionsCredit,
  !withFluctuations && !withPartialConversions && ColumnConversions,
  withPartialConversions ? ColumnPartialConversionRate : ColumnConversionRate,
  ColumnAdvertiserReportedRevenue,
  ColumnRevenueOnAdSpend,
  withPartialConversions ? ColumnAllPartialConversionCPA : ColumnAllConversionCPA,
  withPartialConversions ? ColumnAllConversionsCredit : ColumnAllConversions,
  withPartialConversions ? ColumnAllPartialConversionRate : ColumnAllConversionRate,
  ColumnAllConversionAdvertiserReportedRevenue,
  ColumnAllConversionRevenueOnAdSpend,
  isCPSEnabled && ColumnSalesCount,
  isInstallColumnsEnabled && ColumnInstalls,
  isInstallColumnsEnabled && ColumnCostPerInstall,
  isInstallColumnsEnabled && ColumnRevenuePerInstall,
  isConversionValueRuleColumnsEnabled && ColumnAdvertiserReportedRevenueAdjustment,
  isConversionValueRuleColumnsEnabled && ColumnAllConversionAdvertiserReportedRevenueAdjustment,
  isConversionValueRuleColumnsEnabled && ColumnViewThroughConversionsRevenueAdjustment,
  isNewCustomerAcquisitionColumnsEnabled && ColumnNewCustomerConversions,
  isNewCustomerAcquisitionColumnsEnabled && ColumnNewCustomerRevenue,
  isNewCustomerAcquisitionColumnsEnabled && ColumnNewCustomerConversionRate,
  isNewCustomerAcquisitionColumnsEnabled && ColumnNewCustomerCPA,
  isNewCustomerAcquisitionColumnsEnabled && ColumnNewCustomerRevenueOnAdSpend,
]);

export const conversionsColumns = getConversionColumns();
export const conversionsColumnsWithFluctuation = getConversionColumns({ withFluctuations: true });

